export default class TokenExpiredException extends Error {
  constructor(message) {
    super(message); // (1)
    this.name = 'TokenExpiredException'; // (2)
  }
}
